<div class="first-block position-relative page-header qatch-home-container" data-parallax="true"
  style="background-image: url(../../../../../../assets/img/home/other_images/2.jpg);">
  <div class="banner-overlay">
    <div class="w-90 d-flex h-100 text-block">
      <div class="home-signup-form {{isMobile ? 'mx-auto text-center' : 'my-lg-auto text-start'}}">
        <div class="author" data-aos="zoom-in">
          <div class="home-heading"><span>A Virtual</span> Shopper At Your <span>Fingertips</span></div>
        </div>
        <div class="first-block-description vmt-4" data-aos="zoom-in">
          Curated style content and product recommendations delivered in fun, bite-sized conversations - personalized to you
        </div>
        <br />
        <div class="ms-3 ms-md-0 {{ isMobile ? 'vmt-8 text-center' : 'vmt-2' }}">
          <q-button title="Learn More" (click)="onSignup();"></q-button>
        </div>
      </div>
    </div>
  </div>
</div>